import { useShallow } from 'zustand/react/shallow';
import useAuthStore from '../auth.store.js';

const useAuth = ()=>{
    const { isLoggedIn, isInitializing } = useAuthStore(useShallow((store)=>({
            isLoggedIn: store.isLoggedIn,
            isInitializing: store.isInitializing
        })));
    return {
        isLoggedIn,
        isInitializing
    };
};

export { useAuth as default };
//# sourceMappingURL=useAuth.js.map
